import { render } from "./Verify.vue?vue&type=template&id=53cbb3c7"
import script from "./Verify.vue?vue&type=script&setup=true&lang=js"
export * from "./Verify.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/Verify.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53cbb3c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53cbb3c7', __exports__)) {
    api.reload('53cbb3c7', __exports__)
  }
  
  module.hot.accept("./Verify.vue?vue&type=template&id=53cbb3c7", () => {
    api.rerender('53cbb3c7', render)
  })

}


export default __exports__